export { FeatureBento as FeatureGrid } from "../feature-bento"
export type { FeatureBentoProps as FeatureGridProps } from "../feature-bento"